<template>
    <breakpoint>
        <div id="app" slot-scope="{ smDown, mdOnly }">
            <header>
                <div class="flex items-end ">
                    <router-link class="logo" to="/">Home</router-link>
                    <img
                        class="logo-app"
                        src="@/assets/imgs/logo-app.png"
                        alt="Copeland Product Viewer logo"
                    />
                    <div
                        class="share absolute st-custom-button"
                        data-network="sharethis"
                    >
                        Share
                    </div>
                    <div
                        @click="navShown = !navShown"
                        :class="{ open: navShown }"
                        class="mobile-menu"
                        v-if="smDown || mdOnly"
                    >
                        Menu
                    </div>
                </div>
            </header>
            <transition name="slide-down">
                <main-nav
                    :sections="sections"
                    v-show="
                        !(smDown || mdOnly) || ((smDown || mdOnly) && navShown)
                    "
                ></main-nav>
            </transition>
            <!-- temp -->
            <info-panel :panel-info="currentInfoPanel"></info-panel>
            <router-view />
            <portrait-lock />
            <cookie-policy />
            <portal-target name="video-modal"> </portal-target>
        </div>
    </breakpoint>
</template>

<script>
import MainNav from './components/main-nav';
import InfoPanel from './components/info-panel';
import CookiePolicy from './components/cookie-policy';
import PortraitLock from './components/portrait-lock';
import { isMobileOnly } from 'mobile-device-detect';
import { mapState, mapActions } from 'vuex';

export default {
    components: { MainNav, InfoPanel, CookiePolicy, PortraitLock },
    data() {
        return {
            navShown: false
        };
    },
    computed: {
        ...mapState(['currentInfoPanel']),
        ...mapState('sections', ['sections']),
        isPortraitMode() {
            return isMobileOnly || window.innerWidth < 1024;
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...mapActions(['loadData']),
        hideNav() {
            if (this.isPortraitMode) {
                this.navShown = false;
            }
        }
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        $route(to, from) {
            if (to.meta.infoPanel && to.meta.infoPanel === 'products') {
                this.hideNav();
            }
        }
    }
};
</script>

<style lang="scss">
@import 'assets/sass/app';
</style>
